export default __webpack_public_path__ + "images/c8e8f0d901a041a8567d79ceed0e57bf-fallevents.jpg";